<div #backdrop class="element-blocker {{ theme }}" [class.page]="isPageBlocker">
    <mat-spinner color="primary"></mat-spinner>
</div>
